import React, { useContext } from 'react';
import classNames from 'classnames';
import { codes } from '../../../../data/translations';
import classes from './styles/index.module.scss';
import { TranslationContext } from '../../../translations';

import { getItemClasses } from './utils';
import { gray, white } from '../../../../components/Color';
import { ThemeStyle } from '../../../../utils/const';
import { useStyleContextState } from '../../../styleContext';
import { SignOut } from '../../../../components/Icons/SignOut';
import { useUserProfileLogoutMutation } from '../../../user/userProfile/hooks/useUserProfileLogoutMutation';

const HeaderUserActionsLogout = () => {
	const { theme } = useStyleContextState();
	const { translate } = useContext(TranslationContext);
	const [logoutMutation] = useUserProfileLogoutMutation();
	const componentClasses = classNames('metro-popup-caller', getItemClasses({ theme }));
	const iconColor = theme === ThemeStyle.Dark ? white : gray[7];

	return (
		<button
			type='button'
			className={componentClasses}
			onClick={logoutMutation}
		>
			<SignOut
				className={classes.buttonIcon}
				fill={iconColor}
			/>
			<span>{translate(codes.logOut)}</span>
		</button>
	);
};

export default HeaderUserActionsLogout;
